import { Select } from "@/components/ui/Select";
import {
  OBJECT_EFFECT_PRESETS,
  type ObjectEffectPresetKey,
} from "@mind-sands/shared";
import { LabeledRow } from "./shared";

/**
 * Semantic light preset picker. Writes `effects.preset` on the SpaceObject
 * (via the parent) — the compiler expands it into concrete lights/emitters.
 */
export function LightPresetSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="mb-3 pb-2 border-b border-sands-100">
      <LabeledRow label="Light">
        <Select value={value} onChange={(e) => onChange(e.target.value)}>
          <option value="">None</option>
          {(Object.keys(OBJECT_EFFECT_PRESETS) as ObjectEffectPresetKey[]).map(
            (key) => (
              <option key={key} value={key}>
                {key.charAt(0).toUpperCase() + key.slice(1)}
              </option>
            ),
          )}
        </Select>
      </LabeledRow>
    </div>
  );
}
